export const a11yProps = (index, tabName = 'simple-tab') => {
  return {
    id: `${tabName}-${index}`,
    'aria-controls': `${tabName}panel-${index}`,
  };
};
